// Centralized token storage helper.
// Uses sessionStorage instead of localStorage to reduce XSS exposure:
// the token is cleared when the browser tab closes.
const KEY = "gmc_admin_token";
const store = typeof window !== "undefined" ? window.sessionStorage : null;

export const tokenStorage = {
  get: () => (store ? store.getItem(KEY) : null),
  set: (token) => store && store.setItem(KEY, token),
  clear: () => store && store.removeItem(KEY),
};
